import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { PassAmcInformationEffect } from './pass-amc-information.effect';
import { passengerAmcInformationReducer } from './pass-amc-information.reducer';
import { PASS_AMC_INFORMATION_STORE_NAME, PassAmcInformationState } from './pass-amc-information.state';

/** Token of the PassAmcInformation reducer */
export const POST_PASS_ACM_INFORMATION_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<PassAmcInformationState, Action>
>('Feature PassAmcInformationState Reducer');

/** Provide default reducer for PassAmcInformationState store */
export function getPassengerAmcInformationReducer() {
  return passengerAmcInformationReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(PASS_AMC_INFORMATION_STORE_NAME, POST_PASS_ACM_INFORMATION_REDUCER_TOKEN),
    EffectsModule.forFeature([PassAmcInformationEffect]),
  ],
  providers: [{ provide: POST_PASS_ACM_INFORMATION_REDUCER_TOKEN, useFactory: getPassengerAmcInformationReducer }],
})
export class PassAmcInformationStoreModule {
  public static forRoot<T extends PassAmcInformationState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<PassAmcInformationStoreModule> {
    return {
      ngModule: PassAmcInformationStoreModule,
      providers: [{ provide: POST_PASS_ACM_INFORMATION_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
